import { defineCustomElement } from '@tyler-components-web/core';
import { TabComponent } from './tab';
export * from './tab-adapter';
export * from './tab-constants';
export * from './tab-foundation';
export * from './tab';
export function defineTabComponent() {
    defineCustomElement(TabComponent);
}
